
    <nav [class.fixed]="fixedValue">
      <ng-content></ng-content>
    </nav>
  